<template>
    <div>
       <v-card :color="color">
          <v-card-text>
            <v-layout wrap>
              <span class="pa-3 mt-3" style="font-size:16px;font-weight:400;">{{title}}</span>
              <v-btn-toggle small v-model="toggle_filter" dense mandatory color="info" class="btn-filter-group pa-3">
                  <v-btn class='btn-period' @click="monthlyClick">
                    Monthly
                  </v-btn>

                  <v-btn class='btn-period' @click="quartelyClick">
                    Quartely
                  </v-btn>

                  <v-btn class='btn-period' @click="yearlyClick">
                    Yearly
                  </v-btn>
                </v-btn-toggle>
                <v-autocomplete
                  class="col-md-3 col-sm-12 col-xs-12 pa-3"
                  v-model="selectedFilter.firstFilterId"
                  item-value="id" 
                  item-text="name"
                  :items="firstFilters"
                  :label="firstFilterLabel"
                  hide-details
                  outlined
                  auto-select-first
                  @change="search"
                ></v-autocomplete>
                <v-card
                max-width="330"
                height="180"
                class="summary-card"
                outlined
                v-if="summary && summary.length"
                >
                  <v-card-text>
                    <p class="text-h6 text--primary">
                      {{summaryTitle}}
                    </p>
                    <div class="text--primary" v-for="item, index in summary" :key="index" style="font-size:14px;margin:5px;">
                      {{item.label}}: <strong>{{item.data | thousandSeprator}}</strong>                  
                    </div>
                  </v-card-text>
                </v-card>
            </v-layout>
            <v-row justify="center" align="center" style="margin-top:20px;">
              <v-col cols="12" sm="12" md="9" lg="9" >
                <canvas :id="id" width="500" height="200" ></canvas>
              </v-col>
            </v-row>
            <v-row justify="center" align="center" style="margin-top:20px;margin-bottom:20px;" v-if="detail">
              <v-col cols="12" align="end" sm="12" md="9" lg="9" >
                <v-btn color="info" @click="detailClick">Details</v-btn>
              </v-col>           
            </v-row>
          </v-card-text>
       </v-card>
    </div>
</template>
<script>
import Chart from 'chart.js';
export default {
  name: 'Bar-Chart',
  props: {
    id: {type: String},
    title: {type: String},
    filters: {type: Array},
    firstFilters: {type: Array},
    firstFilterLabel: {type: String},
    labels: {type: Array},
    datasets: {type: Array},
    summaryTitle: {type: String},
    summary: {type: Array},
    detail: {type: Boolean},
    color: {type: String},
    yAxes: {type: Object}
  },
  data() {
    return {
      toggle_filter: 0,
      selectedFilter: {
        monthly: true,
        quarterly: false,
        yearly: false,
        firstFilterId: ''
      }
    }
  },
  mounted() {
    this.renderChart()
  },
  watch: {
    labels() {
      this.renderChart()
    },
    datasets() {
      this.renderChart()
    }
  },
  methods: {
    detailClick() {
      this.$emit('detailClick')
    },
    monthlyClick() {
      if (this.selectedFilter.monthly) {
        return;
      }
      this.changePeriodGroup('monthly')
    },
    quartelyClick() {
      if (this.selectedFilter.quarterly) {
        return;
      }
      this.changePeriodGroup('quarterly')
    },
    yearlyClick() {
      if (this.selectedFilter.yearly) {
        return;
      }
      this.changePeriodGroup('yearly')
    },
    changePeriodGroup(period) {
      this.selectedFilter.monthly = (period === 'monthly')
      this.selectedFilter.quarterly = (period === 'quarterly')
      this.selectedFilter.yearly = (period === 'yearly')
      this.search()
    },
    search() {
      this.$emit('searchfilter', this.selectedFilter)
    },
    renderChart() {
      var ctx = document.getElementById(this.id);
      const config = {
        type: 'bar',
        data: {
          'labels': this.labels,
          'datasets': this.datasets
        }
      }
      // options
      let options = {
        responsive: true,
        interaction: {
          intersect: false
        }
      }
      if (this.id !== 'spend_revenue_chart') {
        options.scales = {
          x: {
            stacked: true
          },
          y: {
            stacked: true
          },
          yAxes: [{
            ticks: {
              min: this.yAxes.min,
              max: this.yAxes.max,
              stepSize: this.yAxes.stepSize
            },
            scaleLabel: {
              display: true,
              labelString: this.yAxes.label
            }
          }]
        }
        if (this.id === 'campaign_spend_cogs_chart') {
          options.scales.yAxes[0].ticks.callback = function (value) {
            return value + '%';
          }
        }
        //   options.scales.yAxes = [{
        //     ticks: {
        //       min: this.yAxes.min,
        //       max: this.yAxes.max,
        //       stepSize: this.yAxes.stepSize,
        //       callback: function (value) {
        //         return value + '%';
        //       }
        //     },
        //     scaleLabel: {
        //       display: true,
        //       labelString: this.yAxes.label
        //     }
        //   }]
        // } else {
        //   options.scales.yAxes = [{
        //     ticks: {
        //       min: this.yAxes.min,
        //       max: this.yAxes.max,
        //       stepSize: this.yAxes.stepSize
        //     }
        //   }]
        // }
      }
      config.options = options
      if (this.id === 'campaign_speed_turnaround_chart') {
        if (window.speedTurnaroundChart !== undefined) {
          window.speedTurnaroundChart.destroy()
        }
        // eslint-disable-next-line
        window.speedTurnaroundChart = new Chart(ctx, config)
      } else if (this.id === 'campaign_spend_cogs_chart') {
        if (window.spendCogsChart !== undefined) {
          window.spendCogsChart.destroy()
        }
        // eslint-disable-next-line
        window.spendCogsChart = new Chart(ctx, config)
      } else if (this.id === 'spend_revenue_chart') {
        if (window.spendRevenueChart !== undefined) {
          window.spendRevenueChart.destroy()
        }
        // eslint-disable-next-line
        window.spendRevenueChart = new Chart(ctx, config)
      }
    }
  }
}
</script>
<style scoped>
.btn-filter-group {
  background: none!important;
}
.btn-period {
  height: 56px!important
}
.summary-card {
  margin-left: auto;
  overflow:scroll;
  overflow-x:auto;
}
</style>



// WEBPACK FOOTER //
// Bar.vue?2664129f